"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RowConfig;
exports.useRowConfig = useRowConfig;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RowConfigContext = /*#__PURE__*/_react.default.createContext([]);
function useRowConfig() {
  return _react.default.useContext(RowConfigContext);
}
function RowConfig({
  children,
  columns
}) {
  return /*#__PURE__*/_react.default.createElement(RowConfigContext.Provider, {
    value: columns
  }, /*#__PURE__*/_react.default.createElement("div", null, children));
}